import React from 'react';
import { X, MapPin, ExternalLink } from 'lucide-react';

export default function LocationMapModal({ isOpen, onClose, name, code, latitude, longitude }) {
  if (!isOpen) return null;

  const hasCoords = latitude !== undefined && latitude !== null && latitude !== '' &&
                    longitude !== undefined && longitude !== null && longitude !== '';

  const mapSrc = hasCoords
    ? `https://maps.google.com/maps?q=${encodeURIComponent(latitude)},${encodeURIComponent(longitude)}&z=16&output=embed`
    : null;
  const externalUrl = hasCoords
    ? `https://www.google.com/maps?q=${encodeURIComponent(latitude)},${encodeURIComponent(longitude)}`
    : null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />

      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col overflow-hidden">
        <div className="bg-gradient-to-r from-slate-800 to-slate-700 px-6 py-4 shrink-0">
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-center gap-3 min-w-0">
              <div className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center shrink-0">
                <MapPin size={16} className="text-white" />
              </div>
              <div className="min-w-0">
                <p className="text-white font-bold text-sm truncate">{name || 'Physical Location'}</p>
                <p className="text-white/60 text-xs font-mono mt-0.5">
                  {code ? `Code: ${code} · ` : ''}{hasCoords ? `${latitude}, ${longitude}` : 'No coordinates on file'}
                </p>
              </div>
            </div>
            <button onClick={onClose} className="text-white/70 hover:text-white transition-colors shrink-0">
              <X size={20} />
            </button>
          </div>
        </div>

        <div className="flex-1 bg-gray-100 min-h-[360px]">
          {hasCoords ? (
            <iframe
              title={`map-${code || name}`}
              src={mapSrc}
              className="w-full h-full min-h-[360px] border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          ) : (
            <div className="flex flex-col items-center justify-center h-full text-center text-gray-400 py-16">
              <MapPin size={32} className="opacity-30 mb-3" />
              <p className="text-sm font-semibold text-gray-500">No coordinates saved for this location</p>
            </div>
          )}
        </div>

        {hasCoords && (
          <div className="px-6 py-3 bg-white border-t border-gray-100 flex justify-end shrink-0">
            <a
              href={externalUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-xs font-semibold text-slate-700 hover:text-slate-900 transition-colors"
            >
              <ExternalLink size={12} /> Open in Google Maps
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
